/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Stack, Card, ButtonGroup, ToggleButton, Image } from 'react-bootstrap';

import { Titre } from '../Fonctions';

/// Couleurs
import blanc from "../../images/blanc.webp";
import gris_metal from "../../images/gris_metal.webp";
import beige from "../../images/beige.webp";

const couleurs = [
	{name: "Blanc", value: 0, img: blanc},
	{name: "Gris métalisé", value: 1, img: gris_metal},
	{name: "Beige", value: 2, img: beige},
];

function Couleur({ couleur, setCouleur }) {
	const debug = false;

	return (
		<Stack gap={2}>
			<Titre>Couleur</Titre>
			<Card style={{ width: '95%' }}>
				<ButtonGroup>
					{couleurs.map((radio, idx) => (
					<ToggleButton
						key={idx}
						id={`radio-${idx}`}
						type="radio"
						variant={'outline-dark'}
						name="radio"
						checked={couleur === radio.value}
						onChange={(e) => setCouleur(radio.value)}>
						<Stack gap={2}>
							<Image src={radio.img} style={{ width: '20%', display: 'block', margin: 'auto', boxShadow: '1px 1px 1px -1px black' }} alt='couleur-img'/>
							{radio.name}
						</Stack>
					</ToggleButton>
					))}
				</ButtonGroup>
				{debug ? couleur : null}
			</Card>
		</Stack>
	);
}

export default Couleur;
